

var Model = require("../types/Model.js");

module.exports = Model({
	name: "online",
	init: init,
	listeners: listeners
});

function init() {
	this.push(true);
}

function listeners() {
	return {
		"connectivity:online": handle_online,
		"connectivity:offline": handle_offline,
	};
}

function handle_online() {
	this.push(true);
}

function handle_offline() {
	this.push(false);
}
